import { useState } from "react";
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  VStack,
  Heading,
  Text,
  Code,
  useToast,
} from "@chakra-ui/react";
import baseUrl from "../../../config/baseURL";
import { useParams } from "react-router-dom";

export default function WhatsAppSendPage() {
    const {orgId} = useParams();
  const [conversationId, setConversationId] = useState("");
  const [organizationId, setOrganizationId] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const toast = useToast();

  const sendMessage = async () => {
  if (!baseUrl) {
    toast({ title: "Base URL is required", status: "warning" });
    return;
  }

  const endpoint = `${baseUrl}/core/webhook/receive/`;

  // Simulated Meta WhatsApp webhook structure
  const dummyWebhook = {
    object: "whatsapp_business_account",
    entry: [
      {
        id: "1234567890",
        changes: [
          {
            value: {
              messaging_product: "whatsapp",
              metadata: {
                display_phone_number: "263776147824",
                phone_number_id: "263776147824",
              },
              contacts: [
                {
                  profile: { name: "Test User" },
                  wa_id: "263776147824",
                },
              ],
              messages: [
                {
                  from: "263776147824",
                  id: "wamid.HBgMNjM3NzYxNDc4MjQQFQIAEhggQkMxRjUyRDJCMURCMjZFQzA0OUMzQjQ2M0E3NTZFQjE=",
                  timestamp: Math.floor(Date.now() / 1000).toString(),
                  type: "text",
                  text: { body: message.trim() || "Hello from dummy webhook!" },
                },
              ],
            },
            field: "messages",
          },
        ],
      },
    ],
  };

  setLoading(true);
  setResult(null);

  try {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dummyWebhook),
    });

    const data = await res.text().then((t) => {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    });

    setResult(data);

    if (res.ok) {
      toast({ title: "Dummy webhook sent successfully", status: "success" });
    } else {
      toast({ title: `Server Error: ${res.status}`, status: "error" });
    }
  } catch (err) {
    toast({
      title: "Network or CORS error",
    //   description: err.message,
      status: "error",
    });
  } finally {
    setLoading(false);
  }
};


//   const sendMessage = async () => {
//     if (!baseUrl) {
//       toast({ title: "Base URL is required", status: "warning" });
//       return;
//     }
//     if (!message.trim()) {
//       toast({ title: "Please enter a message", status: "warning" });
//       return;
//     }

//     const endpoint = `${baseUrl}/webhook/receive/`;
//     const payload = { body: message.trim() };

//     setLoading(true);
//     setResult(null);

//     try {
//       const res = await fetch(endpoint, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       const data = await res.text().then((t) => {
//         try {
//           return JSON.parse(t);
//         } catch {
//           return t;
//         }
//       });
//       setResult(data);

//       if (res.ok) {
//         toast({ title: "Message sent successfully", status: "success" });
//       } else {
//         toast({ title: `Server Error: ${res.status}`, status: "error" });
//       }
//     } catch (err) {
//       toast({
//         title: "Network or CORS error",
//         // description: err.message,
//         status: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

  return (
    <Container maxW="lg" py={10}>
      <VStack spacing={6} align="stretch">
        <Box textAlign="center">
          <Heading size="lg">WhatsApp - Send Message</Heading>
          <Text color="gray.500">
            Standalone test page that POSTs to <Code>/webhook/receive/</Code>
          </Text>
        </Box>
        <FormControl>
          <FormLabel>Message Body</FormLabel>
          <Textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message here..."
            minH="120px"
          />
        </FormControl>

        <Button
          colorScheme="green"
          bg={'#006400'}
          onClick={sendMessage}
          isLoading={loading}
          loadingText="Sending..."
        >
          Send Message
        </Button>

        {result && (
          <Box bg="gray.800" color="green.100" p={4} borderRadius="md" overflowX="auto">
            <pre>{typeof result === "string" ? result : JSON.stringify(result, null, 2)}</pre>
          </Box>
        )}
      </VStack>
    </Container>
  );
}
